export var OperationMode;
(function (OperationMode) {
    OperationMode["Test"] = "test";
    OperationMode["Stage"] = "stage";
    OperationMode["Prod"] = "prod";
})(OperationMode || (OperationMode = {}));
export var Source;
(function (Source) {
    Source["FeelMe"] = "feelme";
    Source["FeelPerformer"] = "feelperformer";
    Source["FeelConnect"] = "feelconnect";
    Source["VideoWatcher"] = "videowatcher";
})(Source || (Source = {}));
